const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_7_Warehouse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 311.406,
    style: {
      fill: "currentColor"
    },
    width: 357.286,
    x: 104.965,
    y: 174.191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "486.34,154.847 486.34,485.588 462.246,485.588 462.246,174.203 104.959,174.203         104.959,485.588 80.864,485.588 80.864,154.847 283.582,70.715       ",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "486.34,154.847 486.34,167.938 283.582,83.807 80.864,167.938 80.864,154.847         283.582,70.715       ",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 15.903,
    style: {
      fill: "currentColor"
    },
    width: 24.095,
    x: 80.864,
    y: 469.685
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 15.903,
    style: {
      fill: "currentColor"
    },
    width: 24.095,
    x: 462.246,
    y: 469.685
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.907,116.903v46.476L283.588,70.7L60.309,163.379v-46.476l215.047-88.462        c5.14-2.691,11.285-2.691,16.464,0L506.907,116.903z",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "506.901,149.444 506.901,163.379 283.582,70.694 60.303,163.379 60.303,149.444         283.582,56.799       ",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.901,116.897v13.895L291.814,42.324c-5.18-2.691-11.324-2.691-16.465,0L60.302,130.792        v-13.895l215.047-88.468c5.14-2.691,11.285-2.691,16.465,0L506.901,116.897z",
    style: {
      fill: "currentColor"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 118.418,
    style: {
      fill: "currentColor"
    },
    width: 118.418,
    x: 204.244,
    y: 367.172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.662,367.152V485.59H204.223v-25.411h40.422c29.04,0,52.605-23.503,52.605-52.605v-40.423        L322.662,367.152L322.662,367.152z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 118.418,
    style: {
      fill: "currentColor"
    },
    width: 118.418,
    x: 322.662,
    y: 367.172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M441.08,367.152V485.59H322.642v-25.411h40.422c29.04,0,52.605-23.503,52.605-52.605v-40.423        L441.08,367.152L441.08,367.152z",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 118.418,
    style: {
      fill: "currentColor"
    },
    width: 118.418,
    x: 263.453,
    y: 248.754
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.899,248.723v118.439H263.461v-25.411h40.422c29.04,0,52.605-23.504,52.605-52.605v-40.423       L381.899,248.723L381.899,248.723z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 36.105,
    style: {
      fill: "currentColor"
    },
    width: 28.765,
    x: 249.07,
    y: 367.172
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 36.105,
    style: {
      fill: "currentColor"
    },
    width: 28.765,
    x: 308.279,
    y: 248.754
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 36.105,
    style: {
      fill: "currentColor"
    },
    width: 28.765,
    x: 367.488,
    y: 367.172
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.857,367.162v36.116h-28.794v-10.952h6.892c6.029,0,10.95-4.861,10.95-10.952v-14.212        H277.857z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.046,248.723v36.116h-28.794v-10.89h6.89c6.091,0,10.952-4.922,10.952-10.952v-14.274        H337.046z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.234,367.162v36.116h-28.732v-10.952h6.892c6.03,0,10.95-4.861,10.95-10.952v-14.212        H396.234z",
    style: {
      fill: "currentColor"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 87.486,
    style: {
      fill: "currentColor"
    },
    width: 87.486,
    x: 3.013,
    y: 398.104
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.499,398.089v87.501H2.998v-18.773h29.863c21.455,0,38.864-17.364,38.864-38.864v-29.864        L90.499,398.089L90.499,398.089z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 87.486,
    style: {
      fill: "currentColor"
    },
    width: 87.486,
    x: 90.499,
    y: 398.104
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.985,398.089v87.501H90.484v-18.773h29.863c21.455,0,38.864-17.364,38.864-38.864v-29.864        L177.985,398.089L177.985,398.089z",
    style: {
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 87.486,
    style: {
      fill: "currentColor"
    },
    width: 87.486,
    x: 46.756,
    y: 310.618
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.263,310.596v87.501H46.762v-18.773h29.863c21.455,0,38.864-17.364,38.864-38.864v-29.864       L134.263,310.596L134.263,310.596z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.674,
    style: {
      fill: "currentColor"
    },
    width: 21.251,
    x: 36.131,
    y: 398.104
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.674,
    style: {
      fill: "currentColor"
    },
    width: 21.251,
    x: 79.874,
    y: 310.618
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.674,
    style: {
      fill: "currentColor"
    },
    width: 21.251,
    x: 123.617,
    y: 398.104
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.398,398.097v26.682H36.125v-8.091h5.092c4.454,0,8.09-3.591,8.09-8.091v-10.5H57.398z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.126,310.596v26.682H79.853v-8.046h5.09c4.5,0,8.091-3.637,8.091-8.091v-10.545H101.126z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.854,398.097v26.682h-21.227v-8.091h5.092c4.454,0,8.09-3.591,8.09-8.091v-10.5H144.854z",
    style: {
      fill: "currentColor"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M508.989,482.577h-19.636V159.353l16.4,6.807c0.921,0.392,1.988,0.282,2.823-0.274    c0.839-0.561,1.341-1.499,1.341-2.506v-46.476c0-1.22-0.737-2.321-1.867-2.784L293.208,25.768c-6.047-3.142-13.248-3.142-19-0.11    L59.162,114.12c-1.129,0.463-1.867,1.564-1.867,2.784v46.476c0,1.008,0.502,1.945,1.341,2.506c0.502,0.333,1.083,0.506,1.67,0.506    c0.393,0,0.784-0.075,1.153-0.231l16.389-6.803v148.25H46.753c-1.663,0-3.012,1.349-3.012,3.012v84.474H3.012    c-1.663,0-3.012,1.349-3.012,3.012v87.485c0,1.663,1.349,3.012,3.012,3.012h505.977c1.663,0,3.012-1.349,3.012-3.012    S510.652,482.577,508.989,482.577z M63.32,158.869v-39.95l213.431-87.811c4.271-2.224,9.384-2.228,13.926,0.118l213.218,87.696    v39.946L284.744,67.917c-0.369-0.153-0.761-0.231-1.153-0.231s-0.784,0.078-1.153,0.231L63.32,158.869z M82.886,313.631h15.228    v20.647H82.886V313.631z M39.144,401.116h7.612h7.616v20.651H39.144V401.116z M87.486,482.577H6.024v-81.461h27.095v23.663    c0,1.663,1.349,3.012,3.012,3.012h21.251c1.663,0,3.012-1.349,3.012-3.012v-23.663h27.091v81.461H87.486z M49.767,395.092V313.63    h27.095v23.66c0,1.662,1.349,3.012,3.012,3.012h21.252c1.662,0,3.012-1.35,3.012-3.012v-23.66h27.091v81.462h-40.73H49.767z     M134.24,401.116h7.616v20.651h-15.228v-20.651H134.24z M174.975,482.577H93.51v-81.461h27.095v23.663    c0,1.663,1.349,3.012,3.012,3.012h21.252c1.663,0,3.012-1.349,3.012-3.012v-23.663h27.095L174.975,482.577L174.975,482.577z     M249.071,406.289h28.766c1.663,0,3.012-1.35,3.012-3.012v-33.092h38.801v112.392H207.254V370.185h38.805v33.092    C246.06,404.939,247.408,406.289,249.071,406.289z M308.277,287.869h28.766c1.663,0,3.012-1.349,3.012-3.012v-33.091h38.805    v112.396h-56.197h-56.198V251.766h38.801v33.091C305.265,286.52,306.614,287.869,308.277,287.869z M311.289,281.845v-30.079    h22.742v30.079H311.289z M438.069,482.577H325.673V370.185h38.801v33.092c0,1.662,1.35,3.012,3.012,3.012h28.766    c1.663,0,3.012-1.35,3.012-3.012v-33.092h38.805V482.577z M393.24,400.265h-22.742v-30.08h11.373h11.369L393.24,400.265    L393.24,400.265z M274.825,370.185v30.08h-22.742v-30.08h11.369H274.825z M459.234,482.577h-15.142V367.173    c0-1.663-1.349-3.012-3.012-3.012h-56.198V248.755c0-1.663-1.349-3.012-3.012-3.012H263.452c-1.663,0-3.012,1.349-3.012,3.012    v115.407h-56.198c-1.662,0-3.012,1.349-3.012,3.012v115.403h-20.231v-84.473c0-1.663-1.35-3.012-3.012-3.012h-40.735v-84.474    c0-1.663-1.349-3.012-3.012-3.012h-26.271V177.214h351.266L459.234,482.577L459.234,482.577z M483.33,482.577h-18.071V174.203    c0-1.663-1.349-3.012-3.012-3.012h-357.29c-1.663,0-3.012,1.349-3.012,3.012v133.404H83.874v-150.75L283.59,73.961l199.74,82.893    L483.33,482.577L483.33,482.577z",
    style: {
      fill: "currentColor"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.7f0663e16febf832dbdb8764dad393b6.svg";
export { ForwardRef as ReactComponent };